"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getMarket = exports.getLocaleFromMarket = exports.getLanguageData = exports.getCurrency = void 0;
var _multibrandLocales = require("@site/multibrand-locales");
var _ContentfulConstants = require("./constants/ContentfulConstants");
var _sharedFunctions = require("./sharedFunctions");
var _constants = require("./constants");
/**
 * Gets the market cookie value
 *
 * @method getMarket
 * @returns {string} market
 */
const getMarket = () => {
  return (0, _sharedFunctions.getCookie)(_constants.LocalizationConstants.MARKET_COOKIE_KEY) || _constants.LocalizationConstants.DEFAULT_MARKET;
};

/**
 * Gets the currency cookie value
 *
 * @method getCurrency
 * @returns {string} currency
 */
exports.getMarket = getMarket;
const getCurrency = () => {
  return (0, _sharedFunctions.getCookie)(_constants.LocalizationConstants.CURRENCY_COOKIE_KEY) || _constants.LocalizationConstants.DEFAULT_CURRENCY;
};
exports.getCurrency = getCurrency;
const getLanguageData = (market, i18n) => {
  if (market) {
    const language = market.split('-')[0];
    if (i18n[market]) {
      return i18n[market];
    } else if (i18n[language]) {
      return i18n[language];
    }
  }
  return i18n[_constants.LocalizationConstants.DEFAULT_MARKET];
};

/**
 * Wrapper for resolveLocaleFromMarket
 * @param market string
 * @returns locale string
 */
exports.getLanguageData = getLanguageData;
const getLocaleFromMarket = market => {
  return (0, _multibrandLocales.resolveLocaleFromMarket)(market, _ContentfulConstants.CONTENTFUL_LOCALES);
};
exports.getLocaleFromMarket = getLocaleFromMarket;